import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  anio: number = 0;
  version: string;
  production = `${environment.production}`;
  apiUrl = `${environment.sgcApi}`;

  constructor(
    private versionService: VersionService
  ) {}

  ngOnInit() {
    this.anio = new Date().getFullYear();
    this.versionService.getVersion().subscribe((version) => {
      this.version = version;
    })
  }
}

